<app-page-banner [bannerContent]="bannerContent"></app-page-banner>
<!-- <app-tab-content3 [articleContent]="dataContent"></app-tab-content3> -->
<app-media-articles></app-media-articles>